module.exports = __webpack_public_path__ + "static/media/ordinaryDoor.ae9ebb4b.jpeg";